(function(){
  /* Working-day delivery window, e.g. "arrives Fri 30 Oct – Tue 3 Nov" */
  function addWorking(d, n){ var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function fmt(d){ try { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/London' }); } catch(e){ return d.toDateString().slice(0,10); } }
  function eta(min, max){ var now = new Date(); return fmt(addWorking(now, min)) + ' – ' + fmt(addWorking(now, max)); }
  function fillEta(scope){
    [].slice.call((scope || document).querySelectorAll('[data-gzc-eta],[data-gza-eta]')).forEach(function(el){
      var host = el.closest('[data-dmin]'); var a = +(el.getAttribute('data-dmin') || (host && host.getAttribute('data-dmin')) || 5), b = +(el.getAttribute('data-dmax') || (host && host.getAttribute('data-dmax')) || 6);
      el.textContent = (el.getAttribute('data-prefix') || 'arrives ') + eta(a, b);
    });
  }

  /* Promo tile: sits after the first full row of visible products (hidden when fewer than 3 show) */
  function placePromo(sec){
    var grid = sec.querySelector('[data-gzc-grid]'), promo = sec.querySelector('[data-gzc-promo]');
    if (!grid || !promo) return;
    var vis = [].slice.call(grid.querySelectorAll('[data-gzc-item]')).filter(function(el){ return !el.hidden; });
    var hide = vis.length < 3; if (promo.hidden !== hide) promo.hidden = hide;
    var cols = (getComputedStyle(grid).gridTemplateColumns || '').split(' ').filter(Boolean).length || 1;
    var ref = vis.length > cols ? vis[cols] : null;
    if (ref) { if (promo.nextElementSibling !== ref) grid.insertBefore(promo, ref); }
    else if (vis.length) { var last = vis[vis.length - 1]; if (last.nextElementSibling !== promo) grid.insertBefore(promo, last.nextElementSibling); }
  }
  function timer(promo){
    var t = promo.querySelector('[data-gzc-timer]'), raw = (promo.getAttribute('data-end') || '').trim();
    if (!t || !raw) return;
    var end = new Date(raw.replace(' ', 'T')); if (isNaN(end)) return;
    var d = t.querySelector('[data-d]'), h = t.querySelector('[data-h]'), m = t.querySelector('[data-m]'), s = t.querySelector('[data-s]');
    function p(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var left = Math.floor((end - new Date()) / 1000);
      if (left <= 0) { t.hidden = true; clearInterval(iv); return; }
      t.hidden = false;
      var dd = Math.floor(left / 86400); left -= dd * 86400; var hh = Math.floor(left / 3600); left -= hh * 3600; var mm = Math.floor(left / 60), ss = left - mm * 60;
      d.textContent = dd + 'd'; d.hidden = dd === 0; h.textContent = p(hh) + 'h'; m.textContent = p(mm) + 'm'; s.textContent = p(ss) + 's';
    }
    var iv = setInterval(tick, 1000); tick();
  }
  function initShop(sec){
    if (sec.__gzcro) return; sec.__gzcro = 1;
    var grid = sec.querySelector('[data-gzc-grid]'), promo = sec.querySelector('[data-gzc-promo]');
    if (grid && promo) {
      var raf = 0; function q(){ if (raf) return; raf = requestAnimationFrame(function(){ raf = 0; placePromo(sec); }); }
      new MutationObserver(q).observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      addEventListener('resize', q); placePromo(sec); timer(promo);
    }
    fillEta(sec);
  }

  /* Icon section: tiles fade up and icons draw in as they scroll into view */
  function initAssure(sec){
    if (sec.__gza) return; sec.__gza = 1; fillEta(sec);
    var items = [].slice.call(sec.querySelectorAll('[data-gza-item]'));
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) { items.forEach(function(el){ el.classList.add('is-in'); }); return; }
    sec.classList.add('is-js');
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { var el = e.target; setTimeout(function(){ el.classList.add('is-in'); }, (+el.getAttribute('data-i') || 0) * 110); io.unobserve(el); } }); }, { threshold: .2 });
    items.forEach(function(el){ io.observe(el); });
  }
  function boot(scope){
    [].slice.call((scope || document).querySelectorAll('[data-gzc]')).forEach(initShop);
    [].slice.call((scope || document).querySelectorAll('[data-gza]')).forEach(initAssure);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function(){ boot(); }) : boot();
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();